var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPasswordProtected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75004 11.5H8.25004L7.77087 8.81249C8.04865 8.6736 8.2674 8.47221 8.42712 8.20832C8.58685 7.94443 8.66671 7.65277 8.66671 7.33332C8.66671 6.87499 8.50351 6.48263 8.17712 6.15624C7.85074 5.82985 7.45837 5.66666 7.00004 5.66666C6.54171 5.66666 6.14935 5.82985 5.82296 6.15624C5.49657 6.48263 5.33337 6.87499 5.33337 7.33332C5.33337 7.65277 5.41323 7.94443 5.57296 8.20832C5.73268 8.47221 5.95143 8.6736 6.22921 8.81249L5.75004 11.5ZM7.00004 17.3333C5.06949 16.8472 3.47574 15.7396 2.21879 14.0104C0.961846 12.2812 0.333374 10.3611 0.333374 8.24999V3.16666L7.00004 0.666656L13.6667 3.16666V8.24999C13.6667 10.3611 13.0382 12.2812 11.7813 14.0104C10.5243 15.7396 8.9306 16.8472 7.00004 17.3333ZM7.00004 15.5833C8.44448 15.125 9.63893 14.2083 10.5834 12.8333C11.5278 11.4583 12 9.93055 12 8.24999V4.31249L7.00004 2.43749L2.00004 4.31249V8.24999C2.00004 9.93055 2.47226 11.4583 3.41671 12.8333C4.36115 14.2083 5.5556 15.125 7.00004 15.5833Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordProtected);
export default __webpack_public_path__ + "static/media/icon-password-protected.e1d49b2a31a66561e6673f7c431aaf0c.svg";
export { ForwardRef as ReactComponent };